import * as React from "react";
import RemindMeBtn from "../RemindMeBtn";
import { TActState } from "../../../../services/product";
import { BottomView1, BottomView2, SoldOutBox, ClockView1, InfoViews2, PcsViewsWrap, BuyNowViewBox, NameViewBox, DiscountNum, } from "./styles";
export const InfoViews = (props) => {
    const { columnNum, isActView, name, price, originalPrice } = props;
    if (columnNum === 1) {
        return NameViews(name, columnNum);
    }
    if (columnNum === 2) {
        return (React.createElement(InfoViews2, null,
            !isActView && NameViews(name, columnNum),
            !isActView && (React.createElement("p", { className: "priceWrap" },
                React.createElement("span", { className: "price" }, price),
                price !== originalPrice && (React.createElement("span", { className: "originalPrice" }, originalPrice))))));
    }
    return null;
};
function BottomView1Box(props) {
    const { columnNum, multiTab, state, stock, soldOut, startTime, isRemindMe, price, originalPrice, remindMe, isInApp, } = props;
    return (React.createElement(BottomView1, null,
        React.createElement("div", { className: "bottomViewsBox" },
            React.createElement("div", { className: "priceWrap" },
                React.createElement("p", { className: "price" }, price),
                React.createElement("p", { className: "originalPrice" }, originalPrice)),
            !soldOut && state === TActState.OnGoing && (React.createElement("div", { className: "stock" },
                PcsViews(stock, state),
                BuyNowViews(columnNum, soldOut))),
            state === TActState.ComingSoon && (React.createElement("div", { className: "remind" },
                !multiTab && ClockViews(startTime),
                React.createElement(RemindMeBtn, { bWidth: "5.6875rem", bHeight: "2rem", isRemindMe: isRemindMe, remindRightBtn: remindMe, isInApp: isInApp })))),
        SoldOutViews(soldOut, columnNum)));
}
function BottomView2Box(props) {
    const { columnNum, multiTab, state, stock, soldOut, startTime, isRemindMe, remindMe, isInApp, } = props;
    return (React.createElement(BottomView2, null,
        React.createElement("div", { className: "bottomViewsBox" },
            (multiTab || state === TActState.OnGoing) && PcsViews(stock, state),
            state === TActState.OnGoing && BuyNowViews(columnNum, soldOut),
            state === TActState.ComingSoon && (React.createElement(React.Fragment, null,
                !multiTab && ClockViews(startTime),
                React.createElement(RemindMeBtn, { bWidth: "5.625rem", bHeight: "1.75rem", isRemindMe: isRemindMe, remindRightBtn: remindMe, isInApp: isInApp }))))));
}
export const BottomViews = (props) => {
    const { columnNum } = props;
    if (columnNum === 1) {
        return React.createElement(BottomView1Box, Object.assign({}, props));
    }
    if (columnNum === 2) {
        return React.createElement(BottomView2Box, Object.assign({}, props));
    }
    return null;
};
export const ImageTagViews = (isActView, discount, columnNum, soldOut) => {
    const discountNum = discount.split("%")[0];
    return (React.createElement(React.Fragment, null,
        !isActView && Number(discountNum) && React.createElement(DiscountNum, null,
            discount,
            " OFF"),
        columnNum === 2 && SoldOutViews(soldOut, columnNum)));
};
const SoldOutViews = (soldOut, columnNum) => {
    if (soldOut) {
        const src = columnNum === 1
            ? "https://i.ezbuy.sg/FrFRRPCUE1KfSk8rzRqcYg9M3nAN"
            : "https://i.ezbuy.sg/FqWviBTrOPaWx_d5sZ8wRUIZ7SuJ";
        return (React.createElement(SoldOutBox, { col: columnNum },
            React.createElement("img", { src: src })));
    }
    return null;
};
const NameViews = (name, columnNum) => {
    return React.createElement(NameViewBox, { col: columnNum }, name);
};
const PcsViews = (num, state) => {
    const isComing = state === TActState.ComingSoon;
    return (React.createElement(PcsViewsWrap, null,
        React.createElement("span", { className: "num" },
            num,
            " "),
        React.createElement("span", { className: "text" },
            "pcs ",
            !isComing && "left")));
};
const BuyNowViews = (columnNum, soldOut) => {
    return (React.createElement(BuyNowViewBox, { col: columnNum, style: {
            background: soldOut
                ? "#ccc"
                : "linear-gradient(129deg, rgba(254, 69, 106, 1) 0%, rgba(227, 13, 5, 1) 100%)",
        } }, "Buy Now"));
};
const ClockViews = (startTime) => {
    return (React.createElement(ClockView1, null,
        React.createElement("img", { src: "https://i.ezbuy.sg/Fv_-bugUtQzuHmV-7H4vn7VlCeyG" }),
        React.createElement("span", null, startTime)));
};
